export const config = {
  restURL: process.env.REACT_APP_REST_URL,
}
